<template>
  <div>
    <ui-modal
      id="informacionGeneralModal"
      ref="modal"
      :title="`Información Booking Confirmado ID: ${idBookingModel} - ${shipperModel} / ${naveName} / ${viajeName} / ${navieraName}`"
      @close="actionSetVisibleModalInformacionGeneral(false), ActionSetZindexTablaModal(false)"
      >
      <!-- size="auto" -->
      <div v-if="load" class="w-100">
        <Loading />
      </div>
      <ui-tabs v-else fullwidth raised disableRipple>
        <!-- Tab de prueba concreto para ser tomado en cuenta -->
        <ui-tab key="informacion" title="Información General">

          <!-- Primera Fila -->
          <div class="d-flex">
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Cliente</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="clienteModel"></p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Shipper</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="shipperModel"></p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POL</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="polModel"></p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POD</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p v-text="podModel"></p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Destino Final</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ destinoFinalModel ? destinoFinalModel : "Sin definir" }}
                </p>
              </div>
            </div>
          </div>

          <!-- Segunda Fila -->
          <div class="d-flex">
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POL ETD</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ polETDModel ? polETDModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">POD ETA</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ podETAModel ? podETAModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Naviera</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ navieraName ? navieraName : "-" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Transbordo</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ transbordoModel ? transbordoModel : "Sin definir" }}
                </p>
              </div>
            </div>

            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Servicio Integral</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ servicioIntegral ? servicioIntegral : "-" }}
                </p>
              </div>
            </div>

          </div>

          <!-- Tercera Fila -->
          <div class="d-flex">
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Stacking From</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ stackingModelFrom ? stackingModelFrom : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Stacking To</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ stackingModelTO ? stackingModelTO : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Corte Documental</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{
                    corteDocumentalModel ? corteDocumentalModel : "Sin definir"
                  }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Corte Documental Anticipado</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{
                    corteDocumentalAnticipadoModel ? corteDocumentalAnticipadoModel : "Sin definir"
                  }}
                </p>
              </div>
            </div>
            
          </div>

          <!-- Cuarta Fila-->
          <div class="d-flex">
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Cantidad</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="cantidadModel"></p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Producto</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="productoModel"></p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Equipo</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ equipoModel ? equipoModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Átmosfera</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ atmosferaName ? atmosferaName : "-" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Temperatura</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ temperaturaModel ? temperaturaModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Ventilación %</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ ventilacionModel ? ventilacionModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Ventilación CBM</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{
                    ventilacionCBMModel ? ventilacionCBMModel : "Sin definir"
                  }}
                </p>
              </div>
            </div>
            <div class="w-50" v-if="showInfoAc">
              <div class="Heading Cell">
                <p class="m-2">Ventilación CO2</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{
                    ventilacionCO2 ? ventilacionCO2 : "Sin definir"
                  }}
                </p>
              </div>
            </div>
            <div class="w-50" v-if="showInfoAc">
              <div class="Heading Cell">
                <p class="m-2">Ventilación O2</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{
                    ventilacionO2 ? ventilacionO2 : "Sin definir"
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- Quinta Fila -->
          <div class="d-flex">
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Tipo Pago</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">{{ pagoModel ? pagoModel : "Sin definir" }}</p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Genset</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ gensetModel ? gensetModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Cold Treatment</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ coldTreatmentModel ? coldTreatmentModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Depósito</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ depositoModel ? depositoModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Consignatario</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2" v-text="consignatarioModel"></p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Notificado</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ notificadoModel ? notificadoModel : "Sin definir" }}
                </p>
              </div>
            </div>
          </div>

          <!-- Sexta Fila -->
          <div class="d-flex">
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Número de contrato</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ contratoModel ? contratoModel : "Sin definir" }}
                </p>
              </div>
            </div>
            <div class="w-50">
              <div class="Heading Cell">
                <p class="m-2">Emisión BL</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">{{ bLModel ? bLModel : "Sin definir" }}</p>
              </div>
            </div>
          </div>

          <!-- Septima Fila -->
          <div class="d-flex">
            <div class="w-100">
              <div class="Heading Cell">
                <p class="m-2">Comentarios</p>
              </div>
              <div class="d-flex justify-content-center Cell h-100">
                <p class="m-2">
                  {{ comentariosModel ? comentariosModel : "Sin definir" }}
                </p>
              </div>
            </div>
          </div>

        </ui-tab>
        <!-- TAB 2 -->
        <ui-tab
          key="historial"
          :title="`Historial de Booking ID: ${idHistorialBooking}`"
          @select="changeStateHistorialAcciones"
        >
          <div>
            <historial-acciones
              v-if="showHistorialAcciones"
              :cabeceras="headers"
              :id="dataDetalle"
              :idItineraryModel="idItineraryModel"
              :constant="constante"
            />
          </div>
        </ui-tab>
      </ui-tabs>
    </ui-modal>
  </div>
</template>

<script>
// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTabs from "keen-ui/src/UiTabs";
import UiTab from "keen-ui/src/UiTab";
import HistorialAcciones from "../../../../common/HistorialAcciones";
import { mapState, mapActions } from "vuex";
import { getHistorialBookingConfirmados } from "../../../../../constants/lineas";
import Loading from "../../../../common/loading.vue";
import moment from 'moment';
export default {
  props: ["data", "dataVer", "load"],
  data() {
    return {
      constante: getHistorialBookingConfirmados,

      idBookingModel: "",
      idItineraryModel: "",
      clienteModel: "",
      shipperModel: "",
      polModel: "",
      podModel: "",
      destinoFinalModel: "",
      polETDModel: "",
      podETAModel: "",
      transbordoModel: "",
      stackingModelFrom: "",
      corteDocumentalModel: "",
      corteDocumentalAnticipadoModel: "",
      stackingModelTO: "",
      cantidadModel: "",
      productoModel: "",
      equipoModel: "",
      temperaturaModel: "",
      ventilacionModel: "",
      ventilacionCBMModel: "",
      pagoModel: "",
      gensetModel: "",
      coldTreatmentModel: "",
      depositoModel: "",
      consignatarioModel: "",
      notificadoModel: "",
      contratoModel: "",
      bLModel: "",
      comentariosModel: "",
      viajeName: "",
      naveName: "",
      navieraName: "",
      servicioIntegral: "",
      atmosferaName: "",
      dataDetalle: "",
      idHistorialBooking: "",
      headers: ["Usuario", "Fecha", "Acción"],
      showHistorialAcciones: false,
      ventilacionCO2: "",
      ventilacionO2: "",
      showInfoAc: "",
    };
  },

  components: {
    UiModal,
    UiTab,
    UiTabs,
    HistorialAcciones,
    Loading,
  },
  computed: {
    ...mapState("lineas", ["visibleModalInformacionGeneral"]),
  },
  methods: {

    ...mapActions(["ActionSetZindexTablaModal"]),

    ...mapActions("lineas", [
      "actionSetVisibleModalInformacionGeneral",
      "actionSetIdAuxiliarBookingSeleccionado",
    ]),

    changeStateHistorialAcciones() {
      this.showHistorialAcciones = true;
    },

    openModal(ref) {
      this.$refs[ref].open();
      this.ActionSetZindexTablaModal(true);
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
  watch: {
    visibleModalInformacionGeneral: function (_new) {
      _new && this.openModal("modal");
    },

    data: function (_new) {
      this.actionSetIdAuxiliarBookingSeleccionado(_new.data[1]);

      this.dataDetalle = _new.data_complementaria.id_booking;
      this.idItineraryModel = _new.data_complementaria.booking_itinerary_id;

      this.idBookingModel = _new.data[0];
      this.clienteModel = _new.data[2];
      this.shipperModel = _new.data[3];
      this.polModel = _new.data[7];
      this.podModel = _new.data[8];
      this.cantidadModel = _new.data[10];
      this.productoModel = _new.data[9];
      this.consignatarioModel = _new.data[6];
      this.idHistorialBooking = _new.data[0];
    },

    dataVer: function (_new) {

      this.destinoFinalModel = _new.destino_final;
      this.polETDModel = moment(_new.pol_etd).format('DD-MM-YYYY');
      this.podETAModel = moment(_new.pod_eta).format('DD-MM-YYYY');
      this.transbordoModel = _new.transbordo;
      this.stackingModelFrom = _new.stacking_from;
      this.stackingModelTO = _new.stacking_to;
      this.corteDocumentalModel = _new.corte_documental ;
      this.corteDocumentalAnticipadoModel = _new.corte_documental_anticipado ;
      this.equipoModel = _new.equipo;
      this.temperaturaModel = _new.temperatura;
      this.ventilacionModel = _new.ventilacion;
      this.ventilacionCBMModel = _new.ventilacion_cbm;
      this.pagoModel = _new.flete;
      this.gensetModel = _new.genset;
      this.coldTreatmentModel = _new.cold_treatment;
      this.depositoModel = _new.deposito;
      this.notificadoModel = _new.notificado;

      if (_new.contrato !== null) {
        this.contratoModel = _new.contrato;
      } else {
        if ( _new.contrato_booking_itineraries.length ) {
          this.contratoModel = 'Otros - ' + _new.contrato_booking_itineraries;
        } else {
          this.contratoModel = 'Otros - ' + _new.contrato_booking;
        }
      }

      if(_new.with_ac === 1) {
        this.ventilacionCO2 = _new.ventilacion_co2;
        this.ventilacionO2 = _new.ventilacion_o2;
        this.showInfoAc = true
      } else {
        this.ventilacionCO2 = "";
        this.ventilacionO2 = "";
        this.showInfoAc = false
      }

      // this.contratoModel = (_new.contrato) ? _new.contrato : 'Otros - ' + _new.contrato_booking;

      

      this.bLModel = _new.emision_bl;
      this.comentariosModel = _new.comentarios;
      this.servicioIntegral = _new.servicio_integral;
      this.atmosferaName = _new.atmosphere_name;
      this.naveName = _new.nave;
      this.viajeName = _new.viaje;
      this.navieraName = _new.naviera_name;

    },
  },
};
</script>
<style>
  
  #informacionGeneralModal .ui-modal__container {
    width: 60% !important;   
  }

.Heading {
  background-color: #ccccca;
  font-weight: bold;
  text-align: center;
}

.Cell {
  border: groove;
  border-width: thin;
}
</style>
